<template>
  <div class="container" draggable="false">
    <img v-if="guideInfo.guideName" class="icon" src="../../../assets/apply_success.png" />
    <img v-else class="icon" src="../../../assets/empty.png" />
    <div class="main-desc" v-if="guideInfo.guideName">
      恭喜您 已成功预约以旧换新的名额<br />
      请添加导购微信告知您的到店换购时间哦~
    </div>
    <div class="main-desc" v-else>
      啊噢，您的手机号不在系统内<br />
      请直接联系平板购买时的门店（或销售顾问）呢~
    </div>
    <div class="guide-box" v-if="guideInfo.guideQrcodeUrl">
      <div class="guide-title">{{ guideInfo.guideName }}</div>
      <div class="guide-network">{{ guideInfo.outletName }}</div>
      <img draggable="false" class="guide-code" :src="guideInfo.guideQrcodeUrl || 'https://market-cdn.anoah.com/dm/static/market-h5-smartguide/guide_code_error.png'" @touchstart="gtouchstart" @touchmove="gtouchmove"
        @touchend="showDeleteButton" />
      <div class="guide-desc">长按识别二维码，添加导购企业微信</div>
    </div>
  </div>
</template>
<script>
const sourceMap = {
  1: '公众号',
  2: '家管',
  3: '平板',
  4: '短信',
};
export default {
  data() {
    return {
      guideInfo: {},
      onShowTime: 0,
      trackData: { pageId: 990011, pageName: '以旧换新报名结果' },
    };
  },
  mounted() {
    const { source, mobile, redirectUrl } = this.$route.query;
    const userPhone = sessionStorage.getItem('oldChangeNew-user-phone');
    // 分享出去的网页必然不会有手机号缓存，需要重定向到报名页面
    if (!userPhone) location.href = redirectUrl;
    const guideInfo = JSON.parse(sessionStorage.getItem('oldChangeNew-guideInfo') || '{}');
    this.guideInfo = guideInfo;
    this.onShowTime = (new Date).getTime();
    this.trackData = {
      ...this.trackData,
      fromChannelName: sourceMap[source] || '',
      fromChannelId: source,
      mobile,
      enrollResult: guideInfo.guideName ? '成功' : '失败',
      QRCode: guideInfo.guideQrcodeUrl ? '是' : '否',
      guideId: guideInfo.guideId || '',
      guideName: guideInfo.guideName || '',
      shopId: guideInfo.outletId || '',
      shopName: guideInfo.outletName || '',
    };
    yjhx.track('PAGE_EXPOSE', this.trackData);
  },
  destroyed() {
    const onHideTime = (new Date).getTime();
    yjhx.track('PAGE_EXIT', {
      ...this.trackData,
      duration: onHideTime - this.onShowTime > 0 ? onHideTime - this.onShowTime : 0,
    });
  },
  methods: {
    //长按事件（起始）
    gtouchstart() {
      var self = this;
      this.timeOutEvent = setTimeout(function () {
        self.longPress();
      }, 500); //这里设置定时器，定义长按500毫秒触发长按事件
      return false;
    },
    //手释放，如果在500毫秒内就释放，则取消长按事件，此时可以执行onclick应该执行的事件
    showDeleteButton() {
      clearTimeout(this.timeOutEvent); //清除定时器
      return false;
    },
    //如果手指有移动，则取消所有事件，此时说明用户只是要移动而不是长按
    gtouchmove() {
      clearTimeout(this.timeOutEvent); //清除定时器
      this.timeOutEvent = 0;
    },
    //真正长按后应该执行的内容
    longPress() {
      this.timeOutEvent = 0;
      yjhx.track('BUTTON_CLICK', {
        ...this.trackData,
        buttonName: '二维码',
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  background: #F5F5F7;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-y: auto;
  padding: 0 30px;

  .icon {
    width: 150px;
    height: 150px;
    margin-top: 45px;
    margin-bottom: 30px;
  }

  .main-desc {
    text-align: center;
    font-size: 15px;
    font-weight: 400;
    color: #555555;
    line-height: 25px;
    margin-bottom: 50px;
  }

  .guide-box {
    width: 100%;
    background: #FFFFFF;
    border-radius: 16px;
    padding: 20px 0;
    display: flex;
    flex-direction: column;
    align-items: center;

    .guide-title {
      font-size: 16px;
      font-weight: 500;
      color: #242424;
      margin-bottom: 5px;
    }

    .guide-network {
      font-size: 14px;
      font-weight: 400;
      color: #666666;
      margin-bottom: 10px;
    }

    .guide-code {
      width: calc(100% - 140px);
      border-radius: 8px;
      margin-bottom: 10px;
    }

    .guide-desc {
      font-size: 13px;
      font-weight: 400;
      color: #909090;
      margin-bottom: 10px;
    }
  }
}
</style>
